import { Form, Input, Button, Space } from "antd";
import { useState } from "react";
import "./SingleFieldForm.css";

const SingleFieldForm = ({ name, label, defaultValue, onSubmit }) => {
  const [value, setValue] = useState(defaultValue);
  const [dirty, setDirty] = useState(false);

  const change = (e) => {
    setValue(e.target.value);
    setDirty(true);
  };

  const save = () => {
    if (!onSubmit) return;

    let payload = {};
    payload[name] = value;

    onSubmit(payload).then(() => setDirty(false));
  };

  const keydown = (value) => {
    if (value.key === "Enter") save();
  };

  const cancel = () => {
    setValue(defaultValue);
    setDirty(false);
  };

  return (
    <Form.Item name={name} label={label}>
      <Input.Group compact>
        <Input
          value={value}
          onChange={change}
          onKeyDown={keydown}
          style={{ width: dirty ? "calc(100% - 150px)" : "100%" }}
        />
        {dirty && (
          <>
            <Button onClick={() => cancel()}>Cancel</Button>
            <Button type="primary" onClick={() => save()}>
              Save
            </Button>
          </>
        )}
      </Input.Group>
    </Form.Item>
  );
};

export default SingleFieldForm;
